export default "__VITE_ASSET__DOHkwqhJ__"